import { AnalyticROIPermissions } from '@/types';
import { LAST_USED_APP, ANALYTICS_ROI_SETTINGS } from '@/constants';
import { useUsersStore } from '@/stores';

export interface CameraMotionBoxSettings {
  showMotionBoxes: boolean;
  showAnalyticBoxes: boolean;
}

export interface MotionBoxSettings {
  [cameraId: string]: CameraMotionBoxSettings;
}

export default function useUserPreference() {
  const usersStore = useUsersStore();

  async function getLastUsedApp() {
    const res = await usersStore.getUserPreference(LAST_USED_APP);

    return res?.data;
  }

  function updateLastUsedApp(value: string) {
    const payload = {
      data: {
        value: value,
      },
    };
    usersStore.updateUserPreference(LAST_USED_APP, payload);
  }

  async function getSelectedEvent() {
    const res = await usersStore.getUserPreference('selectedEvent');
    usersStore.userPreferenceDataForEventsPopover = res?.data;
  }

  async function updateSelectedEvent(newData: object) {
    const existingPreference = usersStore.userPreferenceDataForEventsPopover;

    const mergedData = {
      ...(existingPreference || {}),
      ...newData,
    };

    const payload = {
      data: mergedData,
    };
    usersStore.updateUserPreference('selectedEvent', payload);
    usersStore.userPreferenceDataForEventsPopover = mergedData;
  }

  async function getMotionBoxSettings() {
    const res = await usersStore.getUserPreference('motionBoxSettings');
    usersStore.userPreferenceDataForMotionBoxes = res?.data as MotionBoxSettings | undefined;
    // return type here is example { '1': { showMotionBoxes: true, showAnalyticBoxes: true } }
    return res?.data as MotionBoxSettings | undefined;
  }

  async function getROISettings() {
    const res = await usersStore.getUserPreference(ANALYTICS_ROI_SETTINGS);
    usersStore.userPreferenceDataForROI = res?.data as AnalyticROIPermissions;

    return res?.data as AnalyticROIPermissions | undefined;
  }

  async function updateROISettings(settings: AnalyticROIPermissions) {
    const payload = {
      data: {
        ...settings,
      },
    };
    const result = usersStore.updateUserPreference(ANALYTICS_ROI_SETTINGS, payload);

    return result;
  }

  async function updateMotionBoxSettings(cameraId: string, settings: CameraMotionBoxSettings) {
    const currentSettings = usersStore.userPreferenceDataForMotionBoxes || {};
    const updatedSettings = {
      ...currentSettings,
      [cameraId]: settings,
    };

    const payload = {
      data: updatedSettings,
    };

    usersStore.updateUserPreference('motionBoxSettings', payload);
    usersStore.userPreferenceDataForMotionBoxes = updatedSettings;
  }

  return {
    getLastUsedApp,
    updateLastUsedApp,
    getSelectedEvent,
    updateSelectedEvent,
    getMotionBoxSettings,
    updateMotionBoxSettings,
    getROISettings,
    updateROISettings,
  };
}
